import React from "react";
import Slider from "react-slick";
import { FontAwesome } from 'react-web-vector-icons'

// function SampleNextArrow(props) {
//     const { className, style, onClick } = props;
//     return (
//         <Icon name='angle-right' font='FontAwesome' size={40} color="#333" />
//     );
//   }

// function SamplePrevArrow(props) {
//     const { className, style, onClick } = props;
//     return (
//         <Icon name='angle-left' font='FontAwesome' size={40} color="#333" />
//     );
// }

const slideHomeContainer = () => {
    return (
        <div className="slideHomeContainer"></div>
    )
}

function SampleNextArrow(props) {
    const { style, onClick } = props;
    return (
      <div
        className="arrowCustomer"
        style={{ ...style, display: "flex", background: "transparent", margintLeft: "2vw", cursor: "pointer"}}
        onClick={onClick}
      >
        <FontAwesome
          name='chevron-right'
          color='#222'
          size={30}
        />
      </div>
    );
  }
  
  function SamplePrevArrow(props) {
    const { style, onClick } = props;
    return (
      <div
        className="arrowCustomer"
        style={{ ...style, display: "flex", background: "transparent", margintRight: "2vw", cursor: "pointer"}}
        onClick={onClick}
      >
        <FontAwesome
          name='chevron-left'
          color='#222'
          size={30}
        />
      </div>
    );
  }

export default ({ images, mediaQuery, language }) => {
    const { large, small } = mediaQuery()

    const settings = {
        dots: false,
        draggable: true,
        infinite: true,
        speed: 800,
        arrows: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: large ? true : small ? false : true,
        slidesToShow: language === 'br' ? large ? 3 : small ? 1 : 2 : large ? 3 : small ? 1 : 3,
        slidesToScroll: 1,
        slide: large ? "slideHomeContainer" : small ? "slideHomeContainerMobile" : "slideHomeContainer",
    };

    language === 'br' ? images = images.br : images = images.us
    
    return (
        <div className="SlideCustomerContainer">
            <Slider {...settings}>
                { images.map(imagem => {
                    return (
                    <div className={large ? "SlideHome" : small ? "SlideHomeMobile" : "SlideHome"}>
                        <img src={imagem} className="Body-servicos-img" alt=""/>
                    </div>       
                    )
                })
                }
            </Slider>
        </div>
    )
}